import React from "react";
import { FormUi } from "../../../../ui/FormUi";
import {
  DateFormats,
  FiltersSearch_Types,
  TipoButtonConstants,
} from "../../../../../types/typesConstants";
import { Col, DatePicker, Form, Input, Row, Space } from "antd";
import { SelectUi } from "../../../../ui/SelectUi";
import { ButtonUi } from "../../../../ui/ButtonUi";
import { programacionTejidoStartLoad } from "../../../../../actions/produccion";
import { useDispatch } from "react-redux";
import { parseDateFormatBackEnd } from "../../../../../helpers/utils";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const initialValues = {
  filter_type: FiltersSearch_Types.FECHAEMISION,
  fechainicio: [dayjs(), dayjs()],
  codigo: null,
  proveedor: null,
};
const options = [
  {
    value: FiltersSearch_Types.FECHAEMISION,
    label: "Fecha emisión",
  },
  {
    value: FiltersSearch_Types.CODIGO,
    label: "Código",
  },
  {
    value: FiltersSearch_Types.PROVEEDOR,
    label: "Proveedor",
  },
];

export const ProgramacionTejidoSearchTable = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const filter_type = Form.useWatch("filter_type", form);
  const handleSubmit = (values) => {
    let query = {};
    if (filter_type === FiltersSearch_Types.CODIGO)
      query = { search: values?.codigo };
    else if (filter_type === FiltersSearch_Types.FECHAEMISION)
      query = {
        fechainicio_after: parseDateFormatBackEnd(values?.fechainicio?.[0]),
        fechainicio_before: parseDateFormatBackEnd(values?.fechainicio?.[1]),
      };
    else if (filter_type === FiltersSearch_Types.PROVEEDOR)
      query = { search: values?.proveedor };
    localStorage.setItem("SearhFormTable", JSON.stringify(query));
    dispatch(programacionTejidoStartLoad(query));
  };

  const OnChangeFilterType = () => {
    if (filter_type === FiltersSearch_Types.CODIGO)
      form.setFieldsValue({ fechainicio: null, proveedor: null });
    else if (filter_type === FiltersSearch_Types.PROVEEDOR)
      form.setFieldsValue({ fechainicio: null, codigo: null });
    else form.setFieldsValue({ codigo: null, proveedor: null });
  };
  return (
    <FormUi
      form={form}
      name="advanced_search"
      className="ant-advanced-search-form"
      initialValues={initialValues}
      handleSubmit={handleSubmit}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={8} lg={6} xl={6}>
          <Form.Item name="filter_type" label="Filtrar por">
            <SelectUi
              allowClear
              placeholder="[-TODOS-]"
              data={options}
              onChange={OnChangeFilterType}
            />
          </Form.Item>
        </Col>
        {filter_type === FiltersSearch_Types.FECHAEMISION && (
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Form.Item
              name="fechainicio"
              label="Fecha emisión"
              rules={[
                {
                  required: filter_type === FiltersSearch_Types.FECHAEMISION,
                  message: "Ingrese fecha emisión",
                },
              ]}
            >
              <RangePicker
                format={DateFormats.frontend}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        )}
        {filter_type === FiltersSearch_Types.CODIGO && (
          <Col xs={24} sm={24} md={8} lg={4} xl={4}>
            <Form.Item
              name="codigo"
              rules={[
                {
                  required: filter_type === FiltersSearch_Types.CODIGO,
                  message: "Ingrese código",
                },
              ]}
            >
              <Input placeholder="Ingrese un código" />
            </Form.Item>
          </Col>
        )}

        {filter_type === FiltersSearch_Types.PROVEEDOR && (
          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
            <Form.Item
              name="proveedor"
              rules={[
                {
                  required: filter_type === FiltersSearch_Types.PROVEEDOR,
                  message: "Seleccione proveedor",
                },
              ]}
            >
              <Input placeholder="Ingrese ruc o razón social del proveedor" />
            </Form.Item>
          </Col>
        )}

        <Col xs={12} sm={12} md={8} lg={4} xl={4}>
          <Space wrap>
            <ButtonUi typeUi={TipoButtonConstants.Filtrar} htmlType="submit" />
          </Space>
        </Col>
      </Row>
    </FormUi>
  );
};
